import { useAction, useAtom } from '@reatom/npm-react'
import React, { useMemo } from 'react'
import { useMount } from 'react-use'

import { AsyncStateN, pipe } from '@blade/std-lib'
import {
  loadTradingLeaderboardAction,
  tradingLeaderboardStateAtom,
} from '@root/entities/leaderboard'

import { LeaderboardTable } from './leaderboard-table'

import type { LeaderboardTableEntry } from '@root/features/leaderboard/model'

export const TradingLeaderboardTable: React.FC = () => {
  const [state] = useAtom(tradingLeaderboardStateAtom)
  const loadLeaderboard = useAction(loadTradingLeaderboardAction)

  useMount(() => {
    loadLeaderboard()
  })

  const mappedState = useMemo(
    () =>
      pipe(
        state,
        AsyncStateN.map((it) => {
          return it.map(
            (item): LeaderboardTableEntry => ({
              date: item.registrationDate,
              name: item.username ?? '-',
              amount: item.profitUsd,
              rank: item.position,
              userId: item.id,
              currencyTicker: '$',
            }),
          )
        }),
      ),
    [state],
  )

  return <LeaderboardTable onRetry={loadLeaderboard} items={mappedState} />
}
